const TOKEN_KEY = 'token';
const EMAIL_KEY = 'email';
const LEGACY_PHONE_KEY = 'phone';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null): void {
  if (token == null) {
    localStorage.removeItem(TOKEN_KEY);
  } else {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function getEmail(): string | null {
  return localStorage.getItem(EMAIL_KEY) ?? localStorage.getItem(LEGACY_PHONE_KEY);
}

export function setEmail(email: string | null): void {
  if (email == null) {
    localStorage.removeItem(EMAIL_KEY);
    localStorage.removeItem(LEGACY_PHONE_KEY);
  } else {
    localStorage.setItem(EMAIL_KEY, email);
    localStorage.removeItem(LEGACY_PHONE_KEY);
  }
}
